import React from "react"
import Button from "./button"
export const DeleteButton = (props: { label?: string, onDelete: () => void, message?: string }) => {
    const onDelete = async () => {
        if (!confirm(props.message ?? "Vuoi davvero eliminare l'elemento?"))
            return;
        props.onDelete();
    }
    return <Button
        color="danger"
        onClick={onDelete}>
        <i className="fas fa-trash" /> {props.label ?? "Elimina"}
    </Button>
}